module.exports = __webpack_public_path__ + "img/processing-14.eb031292.gif";